import { Component, inject } from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {FormsModule} from "@angular/forms";
import {HeaderComponent} from "../../../common/header/header.component";

import {Router, RouterLink} from "@angular/router";
import {LocaleService} from "../../../../locale/locale.service";
import {FinishBoxComponent} from "../../../common/finish-box/finish-box.component";
import { ColoredBackgroundComponent } from '../../../common/colored-background/colored-background.component';

@Component({
  selector: 'app-no-processing-possible',
  imports: [
    ColoredBackgroundComponent,
    FooterComponent,
    FormsModule,
    HeaderComponent,
    FinishBoxComponent,
    RouterLink
  ],
  templateUrl: './no-processing-possible.component.html',
  styleUrl: './no-processing-possible.component.css'
})
export class NoProcessingPossibleComponent {
  private router = inject(Router);
  locale = inject(LocaleService);

  nextClicked() {
    this.router.navigate(['/'])
  }
}
